<template>
    <div class="m-title" :style="{'height' : titleHeight}">
        <div style="display: flex;height: 70px;align-items: center;">
            <van-icon @click="back" style="margin-right: 15px;" name="arrow-left" size="25"/>
            <span>
                {{ titleName }}
            </span>
        </div>
    </div>
</template>

<script>


export default {
    name: 'AppTitle.vue',
    props: {
        titleName: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            from: '',
            titleHeight: '70px',
        };
    },
    mounted() {
        this.from = localStorage.getItem('from');
        if (this.from === 'android_box') {
            this.titleHeight = '110px';
        }
    },
    methods: {
        back () {
            this.$router.back();
        }
    }
};
</script>

<style scoped>
    .m-title {
        display: none;
    }

    @media screen and (max-width: 900px) {
        .m-title {
            display: flex;
            font-size: 20px;
            color: #333333;
            width: 100%;
            text-align: left;
            align-items: flex-end;
            padding: 0 10px;
            position: fixed;
            z-index: 999;
            background-color: #f3f1ef;
            box-sizing: border-box;
        }
    }
</style>